import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ExternalSyncControl } from '@/components/ExternalSyncControl';
import { CloudIcon } from 'lucide-react';

export default function ExternalSyncPage() {
  return (
    <div className="w-full">
      <main className="p-4 md:p-6">
        <div className="w-full max-w-6xl mx-auto space-y-6 fade-in">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pt-8 lg:pt-0">
            <div className="flex items-center gap-3">
              <div className="accent-icon-bg">
                <CloudIcon className="h-6 w-6 accent-icon-indigo" />
              </div>
              <h1 className="text-2xl md:text-3xl font-bold text-slate-800 dark:text-slate-200">
                External Database Sync
              </h1>
            </div>
          </div>

          <div className="space-y-6">
            <Tabs defaultValue="overview" className="w-full">
              <TabsList className="mb-6">
                <TabsTrigger value="overview">Overview</TabsTrigger>
                <TabsTrigger value="help">Help & Information</TabsTrigger>
              </TabsList>

              <TabsContent value="overview" className="space-y-6">
                <ExternalSyncControl />
              </TabsContent>

              <TabsContent value="help">
                <Card>
                  <CardHeader>
                    <CardTitle>About External Database Sync</CardTitle>
                    <CardDescription>
                      How the sync process works and troubleshooting tips
                    </CardDescription>
                  </CardHeader>
                  <div className="p-6 space-y-6">
                    <div className="space-y-2">
                      <h3 className="text-lg font-medium">How It Works</h3>
                      <p className="text-slate-600 dark:text-slate-400">
                        The external database sync connects to your landing page database hosted on
                        Replit and automatically imports new leads into your CRM system. The sync
                        process:
                      </p>
                      <ol className="list-decimal pl-6 space-y-2 text-slate-600 dark:text-slate-400">
                        <li>Connects to the external database using secure credentials</li>
                        <li>Retrieves leads that haven't been transferred yet</li>
                        <li>Creates new customer records in your CRM</li>
                        <li>Marks the leads as transferred in the external database</li>
                        <li>Provides detailed logs and status updates</li>
                      </ol>
                    </div>

                    <div className="space-y-2">
                      <h3 className="text-lg font-medium">Automatic Sync Schedule</h3>
                      <p className="text-slate-600 dark:text-slate-400">
                        The system automatically syncs new leads every 15 minutes. You can also
                        trigger a manual sync at any time using the "Start Sync Now" button.
                      </p>
                    </div>

                    <div className="space-y-2">
                      <h3 className="text-lg font-medium">Troubleshooting</h3>
                      <p className="text-slate-600 dark:text-slate-400">
                        If you encounter any issues with the sync process:
                      </p>
                      <ul className="list-disc pl-6 space-y-2 text-slate-600 dark:text-slate-400">
                        <li>Check that the external database is accessible</li>
                        <li>Verify that the database credentials are correct</li>
                        <li>Look for error messages in the sync status</li>
                        <li>Make sure the solar_quotes table exists in the external database</li>
                      </ul>
                    </div>
                  </div>
                </Card>
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </main>
    </div>
  );
}
